export function currencyConverter(price,LOCALE) {
    if (LOCALE){
        let formattedPrice;
        if (LOCALE.toLowerCase() === "fr-ca" || LOCALE.toLowerCase === "fr_ca") {
            formattedPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            formattedPrice = formattedPrice.replace(".", ",");
            formattedPrice = formattedPrice + " $";
        } else {
            formattedPrice = price && price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            formattedPrice = "$" + formattedPrice;
        }

        if(formattedPrice.indexOf("-") === 0) {
            formattedPrice = "("+formattedPrice.substring(1, formattedPrice.length) + ")";
        }
        return formattedPrice;
    }
}

export function priceFormatter(price) {
    return "$" + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}